import { Injectable } from '@angular/core';
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import type { GroupSelectorPostObject } from 'src/AngularJS/Reusables/group-selector.models';
import { GroupSelectorServiceBase } from 'src/shared/services/group-selector-service-base';

@Injectable({
    providedIn: 'root'
})
export class GroupSelectorService extends GroupSelectorServiceBase {
    constructor() {
        super(true);
    }
}
